@if (project$ | async; as projectDetails) {
    <ng-container>
        <ng-container><app-project-details class="skip-element" [projectDetails]="projectDetails"></app-project-details></ng-container>
    </ng-container>
}
